export const FULFILLMENT_ROUTE_NAMES = {
  FULFILLMENT_QUEUE: 'fulfillment-queue',
  SHIPMENT_QUEUE: 'shipment-queue',
};
